import { Link } from "react-router-dom";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar } from "lucide-react";
import type { BlogPost } from "@/hooks/api/blogPosts";

interface BlogCardProps {
  post: BlogPost;
}

export function BlogCard({ post }: BlogCardProps) {
  const publishedDate = post.published_at
    ? format(new Date(post.published_at), "d MMMM yyyy", { locale: fr })
    : null;

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group block border-t border-foreground/20 pt-5"
    >
      {post.cover_image_url && (
        <div className="aspect-[16/9] overflow-hidden bg-muted">
          <img
            src={post.cover_image_url}
            alt={post.title}
            className="h-full w-full object-cover transition-opacity duration-200 group-hover:opacity-90"
          />
        </div>
      )}
      <div className="pt-5">
        {publishedDate && (
          <div className="mb-3 flex items-center gap-2 text-xs text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <span>{publishedDate}</span>
          </div>
        )}
        <h3 className="mb-2 text-[22px] font-semibold tracking-[-.025em] text-foreground transition-colors group-hover:text-primary">
          {post.title}
        </h3>
        {post.excerpt && (
          <p className="text-[14px] leading-6 text-muted-foreground line-clamp-3">{post.excerpt}</p>
        )}
      </div>
    </Link>
  );
}
